import { FileHandlePlugin, FileHandler, type FileHandlerOptions } from "@tiptap/extension-file-handler"
import { PluginKey } from "@tiptap/pm/state"

import { sdk } from "../../../sdk"
import { AssetAttachmentNode } from "../../nodes"

interface AssetFileHandlerOptions extends Pick<FileHandlerOptions, "allowedMimeTypes"> {
	uuid: string
}

export const AssetFileHandler = FileHandler.extend<AssetFileHandlerOptions>({
	name: "AssetFileHandler",
	addProseMirrorPlugins() {
		return [
			FileHandlePlugin({
				key: new PluginKey(this.name),
				editor: this.editor,
				allowedMimeTypes: this.options.allowedMimeTypes,
				onDrop: async (editor, files, pos) => {
					const [offlineAttachments, _promise] = await sdk.assetAttachments.bulkAdd(
						files.map((file) => ({
							asset: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContentAt(
							pos,
							offlineAttachments.map((offlineAttachment) => ({
								type: AssetAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
				onPaste: async (editor, files, _htmlContent) => {
					const [offlineAttachments, _promise] = await sdk.assetAttachments.bulkAdd(
						files.map((file) => ({
							asset: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContent(
							offlineAttachments.map((offlineAttachment) => ({
								type: AssetAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
			}),
		]
	},
})
